// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/media-source-document/relevant-articles/relevant-articles.scss
// module id = 175
// module chunks = 0